import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from 'styled-components';
import Modal from 'styled-react-modal';

import { getThemeColor, getScreenSize } from '../../../utils/theme';

export const StyledModal = Modal.styled`
  width: 30rem;
  height: auto;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${getThemeColor(['white'])};
  position: relative;
`;

export const CloseIconS = styled(FontAwesomeIcon)`
  color: rgba(0, 0, 0, 0.79);
  position: absolute;
  top: 10px;
  right: 10px;
  
  &:hover {
    cursor: pointer;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 22px !important;
    height: 22px;
    top: 18px;
    right: 14px;
  }
`;